module.exports = __webpack_public_path__ + "site/img/footerl.1b0eb576.png";